export default "__VITE_ASSET__PJ5o4J2r__"